import { createStore } from 'vuex';
import global from './Modules/global';
import play from './Modules/play';
import menus from './Modules/menus';
import createPersistedState from 'vuex-persistedstate';

export const store = new createStore({
    modules: {
        global,
        play,
        menus
    },
    plugins: [createPersistedState()],
});
